import Hero from "../components/Hero";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import MainPart from "../components/MainPart";

function Collaborations(){
    return(
        <>
            <Navbar/>
            <Hero
                cName="hero-content" 
                heroImg="https://static.igem.wiki/teams/4696/wiki/hhhero-fig14.jpg"
                title="Collaborations"
            />
            <div className="content-container">
                <div className="sidepanel">
                    <ul>
                        <a href="#1" className="a-sidepanel"><ul class="header">Collaboration with fellow iGEMers</ul></a>
                        
                    </ul>
                </div>
                <MainPart
                    section_id={1}
                    container_cName="main-paragraph-container"
                    heading="Collaboration with fellow iGEMers"
                    subheading_cName='hide'
                    paragraph={[
                        'This year, we have had the opportunity to collaborate with multiple teams, which has greatly influenced the shaping of our research goals and direction. Additionally, these collaborations have allowed us to actively engage in the scientific community and extend our support to other teams.We have collaborated with Rec Chennai Team, Bulgaria Team, Paris Ionis Team for our children story book and translated into Tamil, French and Bulgarian versions. '
                        ,<br/>,<br/>,
                        'In addition to that, we have actively engaged with local fisheries and provided valuable feedback to the Rec Chennai Team regarding their Ocean Acidification (OA) project. It has been a rewarding experience for us to explore a different field and gain insights into the current state of local fisheries. Furthermore, we have contributed to the "iGEM Sticker Shop" initiative by creating a set of stickers. These stickers serve as a means to promote awareness and address the climate crisis by emphasizing the importance of reducing CO2 pollution. We are thrilled that these stickers will be distributed among school students in rec - Chennai., raising awareness and inspiring action among the younger generation.'
                        ,<br/>,<br/>,
                        'Overall, our involvement in these initiatives has broadened our horizons and allowed us to make a positive impact beyond our immediate research focus. We are grateful for the opportunities to collaborate and contribute to these important causes.'
                        
                    ]}
                    img_cName="hide"
                />
            </div>
            <Footer/>
        </>
    )
}

export default Collaborations;